import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarRange, Crown, GitFork, HandCoins, KeyRound, LayoutGrid, Loader2, Megaphone, ShoppingCart, UserCog } from "lucide-react";
import { toast } from "sonner";
import { DashboardShell } from "../components/layout/DashboardShell";
import { OfficeHome } from "../components/office/OfficeHome";
import { NetworkPanel } from "../components/office/NetworkPanel";
import { EarningsPanel } from "../components/office/EarningsPanel";
import { MembershipPanel } from "../components/office/MembershipPanel";
import { ProfilePanel } from "../components/office/ProfilePanel";
import { MarketingPanel } from "../components/office/MarketingPanel";
import { MyCodesPanel } from "../components/office/MyCodesPanel";
import { CodeStorePanel } from "../components/office/CodeStorePanel";
import { MonthlyPanel } from "../components/office/MonthlyPanel";
import { useAuth } from "../lib/auth";
import { api, formatApiError } from "../lib/api";

const TABS = [
  ["inicio", "Inicio", LayoutGrid], ["red", "Mi red", GitFork], ["ganancias", "Comisiones Membresía", HandCoins], ["mensuales", "Ganancias mensuales", CalendarRange],
  ["membresia", "Membresía Dorada", Crown], ["marketing", "Marketing", Megaphone], ["codigos", "Mis códigos", KeyRound], ["tienda", "Comprar códigos", ShoppingCart], ["perfil", "Mi perfil", UserCog],
];

export default function Office() {
  const { logout } = useAuth();
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") || "inicio");
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/me/dashboard");
      setData(d);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const active = data?.profile.membership_status === "activa";
  const tabs = TABS.map((t) => (t[0] === "membresia" && data && !active ? [...t, "!"] : t));

  const renderPanel = () => {
    if (!data) return <Loader2 className="h-6 w-6 animate-spin" />;
    if (tab === "inicio") return <OfficeHome data={data} goTo={setTab} />;
    if (tab === "red") return <NetworkPanel profile={data.profile} />;
    if (tab === "ganancias") return <EarningsPanel active={active} />;
    if (tab === "mensuales") return <MonthlyPanel />;
    if (tab === "membresia") return <MembershipPanel data={data} onActivated={load} />;
    if (tab === "marketing") return <MarketingPanel />;
    if (tab === "codigos") return <MyCodesPanel />;
    if (tab === "tienda") return <CodeStorePanel goTo={setTab} />;
    return <ProfilePanel profile={data.profile} onSaved={load} />;
  };

  return (
    <DashboardShell
      testId="office"
      tabs={tabs}
      tab={tab}
      setTab={setTab}
      subtitle="Oficina virtual"
      onLogout={logout}
      footer={data && (
        <>
          <p className="truncate text-sm font-semibold" data-testid="office-footer-name">{data.profile.name}</p>
          <p className="font-mono text-xs text-[#AEB7D3]">ID {data.profile.dist_id}</p>
        </>
      )}
    >
      {renderPanel()}
    </DashboardShell>
  );
}
